import React from "react";
import { ExternalLink } from "../external-link";
import { ParagraphGroup } from "../paragraph-group";
import style from "./style.module.css";

export interface ICenteredCTAProps {
    body: string;
    cta: string;
    url: string;
    handleNavClick?: (nav: string) => void;
}

export function CenteredCTA(props: ICenteredCTAProps) {
    return (
        <section className={style.centeredCTA}>
            <ParagraphGroup
                body={[props.body]}
                groupStyle={style.paragraphGroup}
            />
            <ExternalLink
                internal={true}
                cta={props.cta}
                url={props.url}
                onNav={props.handleNavClick}
            />
        </section>
    )
}